/**
 * @module broker
 * Moduł umożliwiający komunikację pomiedzy modułami za pośrednictwem magistrali zdarzeń.
 */
app.service('broker', (console) => {
	const $broker = $({});

	const getHandler = elem =>
		elem ? elem : $broker;

	const trigger = (event, data, elem) => {
		console.log('Wywołanie zdarzenia: ' + event);
		const $handler = getHandler(elem);
		return $handler.trigger(event, data);
	};

	const brokerApi = {
		trigger,
		on(event, callback, scope = $broker) {
			$broker.on(event, $.proxy(callback, scope));
			return brokerApi; // umożliwia chaining na brokerze
		},
		off(event) {
			$broker.off(event);
			return brokerApi;
		},
		one(event, callback, scope = $broker) {
			$broker.one(event, $.proxy(callback, scope));
			return brokerApi;
		}
	};

	return brokerApi;

});


